
class LocationMigrationStore {
  // default to using new, and not the old infra
  useOld = false;

  setUseOld(useOld) {
    this.useOld = useOld;
    this.currentState();
  }

  toggle() {
    this.setUseOld(!this.useOld);
    this.currentState();
  }

  currentState() {
    console.log(`Should use old infra? ${this.useOld}`);
  }

}

const locationMigrationStore = new LocationMigrationStore();
export default locationMigrationStore;
